import React from "react";
import "./SampleVoterId.scss";
import VoterIDFront from "../../../assets/docSampleImages/VoterID FRONT.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Voter ID back.jpg";
import GuideModal from "../../UI/GuideModal/GuideModal";
export interface IViewSampleVoterIDPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SampleVoterIDPopup = (props: IViewSampleVoterIDPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Uploading Voter ID"
      titleId="sample-voterid-popup-title"
    >

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Voter ID in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="voterId-Row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Voter ID Front" />
                  <div className="badge">1</div>
                </div>

                <span className="Aadhar-Label">FRONT</span>
              </span>
              <span className="Aadhar-Front-row ml-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Voter ID Back" />
                  <div className="badge">2</div>
                </div>

                <span className="Aadhar-Label">BACK</span>
              </span>
            </span>
          </span>
        </div>
    </GuideModal>
  );
};
export default SampleVoterIDPopup;
